import { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import LoadingOverlay from "./components/LoadingOverlay.jsx";
import Navigation from "./components/Navigation";
import { useUser } from "./contexts/UserContext";
import MedicationRequestChangeBadge from "./pages/pharmacy_dispense_management/MedicationRequestChangeBadge";
import { canAccessPage } from "./utils/roleAccess";

function getCurrentMenu(pathname) {
    if (pathname === "/" || pathname.startsWith("/patient-management") || pathname.startsWith("/print-lab-result")) {
        return "patient_management";
    }
    if (pathname.startsWith("/queue-management")) {
        return "queue_management";
    }
    if (pathname.startsWith("/visiting-management")) {
        return "consultation_room";
    }
    if (pathname.startsWith("/pharmacy-dispense-management")) {
        return "medications_and_supplies";
    }
    if (pathname.startsWith("/payments")) {
        return "payment";
    }
    if (pathname.startsWith("/payment-details")) {
        return "payment";
    }
    if (pathname.startsWith("/inventory")) {
        return "clinic_stock";
    }
    if (pathname.startsWith("/medical-certificate-template")) {
        return "medical_certificate_template";
    }
    if (pathname.startsWith("/appointment-management")) {
        return "appointment";
    }
    if (pathname.startsWith("/follow-up-management")) {
        return "follow_up";
    }
    if (pathname.startsWith("/settings")) {
        return "settings";
    }
    if (pathname.startsWith("/lab-results-list")) {
        return "lab_results_list";
    }
    return "dashboard";
}

function ContentLoadingFallback() {
    return (
        <div className="h-full w-full flex items-center justify-center">
            <LoadingOverlay />
        </div>
    );
}

export default function AppLayout() {
    const location = useLocation();
    const currentMenu = getCurrentMenu(location.pathname);
    const { user, loading } = useUser();
    const canRenderContent = !loading && canAccessPage(user, currentMenu);

    return (
        <div className="flex">
            <Navigation
                currentMenu={currentMenu}
                isExpanded={true}
            />
            <main className="flex-1 h-screen overflow-y-auto">
                {loading ? <div></div> : (canRenderContent ? (
                    <Suspense fallback={<ContentLoadingFallback />}>
                        <Outlet />
                    </Suspense>
                ) : null)}
            </main>
            {user?.role === 'แพทย์' && <MedicationRequestChangeBadge />}
        </div>
    );
}
